import Localization, { TrustedValue } from 'lib/localization';

export default {
  get lxWebNotAvailableHeader() {
    return Localization.get('bumblesite@sunsetstatic.hero.header');
  },

  get lxWebNotAvailableBody() {
    return Localization.get('bumblesite@sunsetstatic.hero.body', {
      __EOL__: TrustedValue.for('<br/>'),
    });
  },
  get lxWebNotAvailableCta() {
    return Localization.get('bumblesite@sunsetstatic.cta');
  },
  get lxWebNotAvailableWhyHeader() {
    return Localization.get('bumblesite@sunsetstatic.whyheader');
  },
  get lxWebNotAvailableWhyHeader1() {
    return Localization.get('bumblesite@sunsetstatic.why.header1');
  },
  get lxWebNotAvailableWhyText1() {
    return Localization.get('bumblesite@sunsetstatic.why.text1');
  },
  get lxWebNotAvailableWhyHeader2() {
    return Localization.get('bumblesite@sunsetstatic.why.header2');
  },
  get lxWebNotAvailableWhyText2() {
    return Localization.get('bumblesite@sunsetstatic.why.text2');
  },
  get lxWebNotAvailableWhyHeader3() {
    return Localization.get('bumblesite@sunsetstatic.why.header3');
  },
  get lxWebNotAvailableWhyText3() {
    return Localization.get('bumblesite@sunsetstatic.why.text3');
  },
  get lxWebNotAvailableGetTheAppHeader() {
    return Localization.get('bumblesite@sunsetstatic.gettheapp.header');
  },
  get lxWebNotAvailableGetTheAppBody() {
    return Localization.get('bumblesite@sunsetstatic.gettheapp.body', {
      __EOL__: TrustedValue.for('<br/>'),
    });
  },
};
